/**
 * @author Lorenzo Muscariello <lmuscariello@ciaopeople.com>
 */
import { loadJS } from "../../../lib/utils/LoadJS.js";

const IMA_URL = "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
const IMA_DEBUG_URL = "https://imasdk.googleapis.com/js/sdkloader/ima3_debug.js"

interface ImaWindow {
    google: {
      ima: typeof google.ima;
    };
  }

let pendingPromise: Promise<typeof google.ima> | null = null;

const promiseFinished = () => {
  pendingPromise = null;
};



interface GoogleWindow {
  google: typeof google
}
/**
 * Downloads ima sdk js 
 * @param debug if true downloads ima debug version
 * @returns a promise that completes as soon as sdk's script is loaded
 */
export const loadImaSdk = (window: Window,debug: boolean = false): Promise<typeof google.ima> => {
    const w = window as unknown as ImaWindow;
    if (w.google && w.google.ima) {
      return Promise.resolve(w.google.ima);
    }
    if (pendingPromise) {
      return pendingPromise;
    }
    pendingPromise = loadJS(debug?IMA_DEBUG_URL:IMA_URL,window.document.head).then(() => w.google.ima);
    pendingPromise.then(promiseFinished).catch(promiseFinished);
    return pendingPromise;
  };


export const getGoogleType = (window: Window): typeof google => {
  
  const w = window as unknown as GoogleWindow;
  if(w.google) return w.google;
  else return null;
}